import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import notifications from '../notifications'
import { login } from '../api/auth';
import './SignUp.css';
import Loader from './common/Loader';

const Login = () => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    userType: 'coach', // Default user type
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await login(formData.email, formData.password);
      if (response.status === 200) {
        navigate('/', { replace: true });
        window.location.reload();
      } else {
        notifications.notifyError('Username/password incorrect');
      }
    } catch (error) {
      console.error('Login error:', error);
      notifications.notifyError('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signUpContainer">
      <ToastContainer />
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </label>
        <br />
        <label>
          Password:
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </label>
        <br />
        <button type="submit" disabled={loading}>
          Login
        </button>
        {loading && <Loader size={40} />}
      </form>
      {/* <Link to="/signup" relative="path">
        Don't have an account yet?
      </Link> */}
    </div>
  );
};

export default Login;